import(/* webpackMode: "eager" */ "/home/mraof/.cache/yay/hedgedoc2/src/hedgedoc-2.0.0-alpha.3/frontend/src/app/(editor)/login/page.tsx");
